import { render } from "./Tile.vue?vue&type=template&id=7528bdaf&scoped=true"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"

import "./Tile.vue?vue&type=style&index=0&id=7528bdaf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7528bdaf"]])

export default __exports__